import { useContext } from 'react'
import { nanoid } from 'nanoid'
import { AppContext } from '@state/context'
import { addToast, removeToast } from '@state/actions/toastsAction'

const useAddToastWithTimer = () => {
  const [, dispatch] = useContext(AppContext)
  const addToastWithTimer = (message, error) => {
    const toast = {
      id: nanoid(),
      message,
      error,
    }
    dispatch(addToast(toast))

    setTimeout(() => {
      requestAnimationFrame(() => {
        dispatch(removeToast(toast.id))
      })
    }, 3000)
  }

  return {
    addToastWithTimer,
  }
}

export { useAddToastWithTimer }
